import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
// import { parseEntityId } from '../entity'

class CorreoElectronico {
  // Correo electronico Exportadores de TQ

  static adaptToBackend (values = {}) {
    const {
      username,
      email,
      asunto,
      motivo,
      mensaje
    } = values

    return {
      nombre: username,
      email: email,
      asunto: asunto || 'Consulta desde Laridae',
      motivo: motivo,
      mensaje: mensaje
    }
  }

  static enviarCorreoConsulta (values) {
    // const axios = getAxiosInstance()
    const valores = this.adaptToBackend(values)
    console.log('Se enviaran valores: ', valores)
  }

  // Correo electronico exportadores

  static async getCorreoExportador (exportador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_correo_exportador?r=` +
        `{"clave":{"exportador": ${exportador}}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data
  }

  static enviarCuposAExportadores (exportador, cereal, cantidadAsignada, fechaDeEmision, tipo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_cupos_a_exportadores?r=` +
        `{"parametros": {"exportador": ${exportador}, "cereal": "${cereal}",
        "cantidad_asignada": ${cantidadAsignada}, "fecha_de_emision": "${fechaDeEmision}",
        "tipo": "${tipo}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarTotalCuposAExportadores (exportador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_total_cupos_a_exportadores?r=` +
        `{"parametros": {"exportador": ${exportador} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarSeleccionCuposAExportadores (exportador, sel) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_seleccion_cupos_a_exportadores?r=` +
        `{"parametros": {"exportador": ${exportador}, "contactos": "${sel}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static eliminarCorreoExportador (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`correo_exportador?r=` +
        `{"clave": {"id": ${id} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static buscarCorreoExportador (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_contacto_exportador?r=` +
        `{"clave": {"id": ${id} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static agregarCorreoExportador (nombre, correo, exportador) {
    const axios = getAxiosInstance()
    const promise = axios.post(`correo_exportador`,
      `{"valores": {"nombre": "${nombre}",
      "exportador": ${exportador}, "correo_electronico": "${correo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static actualizarCorreoExportador (id, nombre, correo, exportador) {
    const axios = getAxiosInstance()
    const promise = axios.put(`correo_exportador`,
      `{"valores": {"nombre": "${nombre}", "exportador": ${exportador}, 
      "correo_electronico": "${correo}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }
}

export default CorreoElectronico
